import type PubNub from 'pubnub';

let activeClient: PubNub | null = null;

export function setActivePubnubClient(client: PubNub | null): void {
  activeClient = client;
}

/** 現在登録中のインスタンスと同じ場合だけ登録を解除する（差し替え後の誤解除防止）。 */
export function clearActivePubnubClient(client: PubNub): void {
  if (activeClient === client) {
    activeClient = null;
  }
}

/** ログアウト時に現在の PubNub クライアントのネットワークを停止する。 */
export function stopActivePubnubClient(): void {
  const client = activeClient;
  activeClient = null;
  if (!client) return;
  try {
    client.stop();
  } catch {
    // 停止失敗はログアウトを妨げない
  }
}
